import type { PlayerStreakDto, StreakXpAwardListDto, StreakXpAwardParams } from './streak.schema';
import { validateWithZod } from '@/utils/zod.utils';
import { ENDPOINTS } from '../endpoints';
import { httpClient } from '../httpClient';
import { PaginationSchema } from '../types/Pagination.types';
import { PlayerStreakDtoSchema, StreakXpAwardDtoSchema, StreakXpAwardParamsSchema } from './streak.schema';

export const streakApi = {
  async getMeStreak(): Promise<PlayerStreakDto> {
    const response = await httpClient.get<PlayerStreakDto>(ENDPOINTS.gamification.streak.me);

    return validateWithZod(PlayerStreakDtoSchema, response);
  },

  async getXpAwards(params?: StreakXpAwardParams) {
    const response = await httpClient.get<StreakXpAwardListDto>(
      ENDPOINTS.gamification.streak.xpAwards,
      { params: params ? validateWithZod(StreakXpAwardParamsSchema, params, 'frontend') : undefined },
    );

    return validateWithZod(PaginationSchema(StreakXpAwardDtoSchema), response);
  },
};
